// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingScreen_container__Fuchc","innerContainer":"LoadingScreen_innerContainer__YZY5o","gif":"LoadingScreen_gif__iQlCY"};